import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";

import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import SnAgChart from "@shared/components/Grid//SnChart";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}

const SN_SAL_ALS_REP_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const cd_menu = Menuprops.cd_menu || "SN_SAL_ALS_REP_001";
  const defaultSize = { panel1height: "50%", panel2height: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
  const [transformed, setTransformed] = useState<any[]>([]);

  const { userInfo } = global();

  const monthMap: { [key: string]: string } = {
    am_01: "1월",
    am_02: "2월",
    am_03: "3월",
    am_04: "4월",
    am_05: "5월",
    am_06: "6월",
    am_07: "7월",
    am_08: "8월",
    am_09: "9월",
    am_10: "10월",
    am_11: "11월",
    am_12: "12월",
  };

  useEffect(() => {
    const fetchform = async () => {
      try {
        const defaultForm = {
          cd_firm: userInfo.cd_firm,
          // cd_biz: userInfo.cd_biz,
        };
        const rtn: any = await getInitFormData();
        setFormData({ ...rtn.formData, ...defaultForm });
        setFormControlData(rtn.formControlData);
        setColums({ grid1: rtn.grid.grid1 });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const rawParams = searchRef.current.getFormdata();
      const param = {
        id: "sn_sal_als_rep_001_01",
        params: {
          ...rawParams,
          yy:
            rawParams.yy && rawParams.yy.length >= 4
              ? rawParams.yy.substring(0, 4)
              : "",
        },
      };
      const data: any = await fnGetDataSet(param);
      console.log(data);

      setDataSources({ grid1: data[1] || [] });

      // const amKeys = Object.keys(dataSources.grid1[0] || {}).filter((k) =>
      //   k.startsWith("am_")
      // );

      // // 데이터 변환: 월별 객체 생성
      // const transformed = amKeys.map((amKey) => {
      //   const row: { [key: string]: any } = { month: monthMap[amKey] ?? amKey };

      //   dataSources.grid1.forEach((entry: any) => {
      //     row[entry.dc_gubun] = entry[amKey];
      //   });

      //   return row;
      // });

      // setTransformed(transformed);
    } catch (error) {}
  };

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  useEffect(() => {
    if (!dataSources.grid1.length) return;

    const amKeys = Object.keys(dataSources.grid1[0] || {}).filter((k) =>
      k.startsWith("am_")
    );

    const transformed = amKeys.map((amKey) => {
      const row: { [key: string]: any } = { month: monthMap[amKey] ?? amKey };

      dataSources.grid1.forEach((entry: any) => {
        row[entry.dc_gubun] = entry[amKey];
      });

      return row;
    });

    setTransformed(transformed);
  }, [dataSources.grid1]);

  const barKeys = ["2025년 목표", "2025년 실적", "2024년 실적"];
  const lineKeys = ["계획대비 달성률", "전년대비 달성률"];

  const barSeries = barKeys.map((key) => ({
    type: "bar",
    xKey: "month",
    yKey: key,
    yName: key,
    // stacked: true,
  }));

  const lineSeries = lineKeys.map((key) => ({
    type: "line",
    xKey: "month",
    yKey: key,
    yName: key,
    marker: { enabled: true },
    strokeWidth: 2,
  }));

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div
        style={{
          display: "flex",
        }}
      >
        <SnAgChart
          type="custom"
          data={transformed}
          xKey="month"
          seriesOptions={{
            series: [...barSeries, ...lineSeries],
          }}
          options={{
            axes: [
              { type: "category", position: "bottom" },
              { type: "number", position: "left" },
            ],
            legend: { position: "bottom" },
          }}
          height={260}
        />
      </div>
      <div className="flex-1">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={198}
        >
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              rowSelection: "multiple",
              title: "월별매출정보",
              isEditable: false,
            }}
          />
        </SnResizable>
      </div>
    </div>
  );
});

export default SN_SAL_ALS_REP_001;
